import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import API from "../API";
export default function JyskFinanceLogin({ initialChallenge = "", workerMode = false }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [challenge, setChallenge] = useState(initialChallenge);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await fetch(`${API.SERVER_ADDRESS}${workerMode && !challenge ? "login" : "jyskfinancelogin"}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          challenge ? { challenge, code } : { email, password },
        ),
      });
      const data = await response.json();
      if (!response.ok || data.error)
        throw new Error(data.message || "Giriş tamamlanamadı.");
      if (data.otpRequired) {
        setChallenge(data.challenge);
        setPassword("");
      } else {
        localStorage.setItem("bearerToken", data.token);
        localStorage.removeItem("cache");
        window.location.assign("/jysk-finance-reports");
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: 3,
        bgcolor: "#f5f8fb",
      }}
    >
      <Paper
        component="form"
        onSubmit={submit}
        sx={{ p: 4, width: "100%", maxWidth: 440 }}
      >
        <Stack spacing={3}>
          <Typography variant="h5">JYSK Finans</Typography>
          {error && <Alert severity="error">{error}</Alert>}
          {challenge ? (
            <>
              <Typography>
                Hesap e-postanıza gönderilen 6 haneli kodu girin. Kod 10 dakika
                geçerlidir.
              </Typography>
              <TextField
                label="Doğrulama kodu"
                autoComplete="one-time-code"
                value={code}
                onChange={(e) =>
                  setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                }
                inputProps={{ inputMode: "numeric", maxLength: 6 }}
                required
              />
              <Button
                disabled={busy}
                onClick={() => {
                  setChallenge("");
                  setCode("");
                  setError("");
                }}
              >
                Yeni kod için tekrar giriş yap
              </Button>
            </>
          ) : (
            <>
              <TextField
                label="Hesap e-postası"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                label="Şifre"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </>
          )}
          <Button
            variant="contained"
            type="submit"
            disabled={busy || (challenge && code.length !== 6)}
          >
            {busy
              ? "Lütfen bekleyin…"
              : challenge
                ? "Doğrula ve giriş yap"
                : "Giriş yap"}
          </Button>
          <Button href="/login">Personel girişi</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
